import React,{useState,useEffect,useImperativeHandle,forwardRef,useRef} from "react"
import AccountAvatar from "../../../images/layout/avatar.png";
import {Popover} from "antd"
import {Link} from "react-router-dom";
import {Path} from "../../public/path";
import IconAccountOrder from "../../../iconfont/account/order";
import IconAccountExit from "../../../iconfont/account/exit";
import CorpApi from "../../public/corp_api";
import mainAccount from "../../../images/account/newMainAccount.png"
import subAccount from "../../../images/account/newSubAccount.png"
import IconPullDown from "../../../iconfont/pullDown/pullDown";

const UserInfo = (props) =>{
    const [data,setData] = useState({})

    useEffect(()=>{
        setData(props.accountMessage)
    },[props.accountMessage])

    function exit() {
        CorpApi.userExit(() => {
            props.props.history.push(Path.getSigninPath())
        });
    }
    return(
        <Popover
            overlayClassName='base_info_pop_up'
            placement="bottom"
            trigger="hover"
            content={
            <div className={'show_base_info'} getPopupContainer={triggerNode => triggerNode.parentNode}>
                <div className={'show_base_info_account'}>{data.account}</div>
                <div className={'show_base_info_account_id'}>账号ID：{data.id}</div>
                {
                    data.isSub == 1 ?
                        <div className={'show_base_info_account_sign'}><img src={subAccount} style={{width:48,height:20}}/></div> :
                        data.isSub == 0 ?
                            <div className={'show_base_info_account_sign'}><img src={mainAccount} style={{width:48,height:20}}/></div> : ''
                }
                <ul className={'show_base_info_order_login'}>
                    {
                        data.isSub == 0 ?
                            <li className={'my_order_style'}><Link to={Path.getMineOrderMyOrder()}><IconAccountOrder/><span >我的订单</span></Link></li> : ''
                    }
                    <li onClick={exit.bind(this)}><IconAccountExit/><span>退出登录</span></li>
                </ul>
            </div>}>
            <li className={'user_info_exhibition'}>
                {
                    data.account != '' ?
                        <>
                            <img src={AccountAvatar} style={{width: '40px', borderRadius: '50%'}}/>
                            <span>
                    <span style={{color:'#595959'}}>{data.account}</span>
                    <span className={'pull_down_arrow'}><IconPullDown/></span>
                </span>
                        </> : <></>
                }
            </li>
        </Popover>
    )
}
export default UserInfo